import { _ as _type_of } from "@swc/helpers/_/_type_of";
export function classNames() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var result = [];
    args.forEach(function(item) {
        if (!item) {
            return;
        }
        switch(typeof item === "undefined" ? "undefined" : _type_of(item)){
            case "string":
                result.push(item);
                break;
            case "object":
                Object.keys(item).forEach(function(key) {
                    if (item[key]) {
                        result.push(key);
                    }
                });
                break;
            default:
                result.push("".concat(item));
        }
    });
    return result.join(" ");
}

//# sourceMappingURL=classNames.js.map